<template>
    <div>
        <el-page-header @back="goBack" content="特属服务对象资料详情"></el-page-header>
        <div class="docker-detail-header" v-if="role_id != 2 && role_id != 24">
            <el-button type="success" @click="edit">编辑</el-button>
            <el-button type="primary" @click="importinfo">导出资料</el-button>
        </div>
        <Box style="margin-top: 20px;">
            <template #body>
                <table class="table" v-if="!is_mobile">
                    <tbody>
                    <tr>
                        <td class="dockert_img_td" rowspan="8">
                            <el-image style="width: 100%;" :src="user_avatar"></el-image>
                        </td>
                        <td class="docker_title_td">特属服务对象姓名</td>
                        <td class="docker_value_td">{{ user_name }}</td>
                        <td class="docker_title_td">所属集团</td>
                        <td class="docker_value_td">{{ bloc_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">手机号码</td>
                        <td class="docker_value_td">{{ mobile }}</td>
                        <td class="docker_title_td">身份证号</td>
                        <td class="docker_value_td">{{ idcard }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">状态</td>
                        <td class="docker_value_td">{{ status }}</td>
                        <td class="docker_title_td">付费到期时间</td>
                        <td class="docker_value_td">{{ pay_expired_date }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">签约特属专家数</td>
                        <td class="docker_value_td">{{ client_doctor_number }}</td>
                        <td class="docker_title_td">健康档案数</td>
                        <td class="docker_value_td">
                            <el-button type="text" @click="goHealthRecord">{{ health_records_number }}</el-button>
                        </td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">尊称</td>
                        <td class="docker_value_td">{{ nick_name }}</td>
                        <td class="docker_title_td">职务</td>
                        <td class="docker_value_td">{{ posistion }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">子账号姓名</td>
                        <td class="docker_value_td">{{ assistant_name }}</td>
                        <td class="docker_title_td">子账号手机号码</td>
                        <td class="docker_value_td">{{ assistant_mobile }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">联系人数量</td>
                        <td class="docker_value_td">
                            {{ user_assistant_number }}
                        </td>
                        <td class="docker_title_td"></td>
                        <td class="docker_value_td"></td>
                        <!--                        <td class="docker_value_td" @click="goAssistan">-->
                        <!--                            <el-button type="text">{{ user_assistant_number }}</el-button>-->
                        <!--                        </td>-->
                    </tr>
                    </tbody>
                </table>
                <table class="table" v-else>
                    <tbody>
                    <tr>
                        <td class="dockert_img_td" colspan="2">
                            <el-image style="float: left; width: 140px" :src="user_avatar"></el-image>
                        </td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">特属服务对象姓名</td>
                        <td class="docker_value_td">{{ user_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">所属集团</td>
                        <td class="docker_value_td">{{ bloc_name }}</td>

                    </tr>
                    <tr>
                        <td class="docker_title_td">手机号码</td>
                        <td class="docker_value_td">{{ mobile }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">身份证号</td>
                        <td class="docker_value_td">{{ idcard }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">状态</td>
                        <td class="docker_value_td">{{ status }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">付费到期时间</td>
                        <td class="docker_value_td">{{ pay_expired_date }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">签约特属专家数</td>
                        <td class="docker_value_td">{{ client_doctor_number }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">健康档案数</td>
                        <td class="docker_value_td">
                            <el-button type="text" @click="goHealthRecord">{{ health_records_number }}</el-button>
                        </td>
                    </tr>

                    <tr>
                        <td class="docker_title_td">尊称</td>
                        <td class="docker_value_td">{{ nick_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">职务</td>
                        <td class="docker_value_td">{{ posistion }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">子账号姓名</td>
                        <td class="docker_value_td">{{ assistant_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">子账号手机号码</td>
                        <td class="docker_value_td">{{ assistant_mobile }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">联系人数量</td>
                        <td class="docker_value_td">
                            {{ user_assistant_number }}
                        </td>
                        <!--                        <td class="docker_value_td" @click="goAssistan">-->
                        <!--                            <el-button type="text">{{ user_assistant_number }}</el-button>-->
                        <!--                        </td>-->
                    </tr>
                    </tbody>
                </table>
            </template>
        </Box>
        <div id="statistics_box" class="message_box">
            <p class="message_title">特属服务对象统计信息</p>
            <table class="table">
                <tbody>
                <tr>
                    <td v-if="role_id == 1">当前签约生效特属专家数</td>
                    <td v-if="role_id != 1">当前签约特属专家数</td>
                    <td>历史签约特属专家总数</td>
                    <td v-if="role_id == 1">签约到期特属专家总数</td>
                    <td>预约处理数量</td>
                    <td>会面中断数量</td>
                    <td>会面完成数量</td>
                </tr>
                <tr>
                    <td>{{ client_doctor_number }}</td>
                    <td>{{ all_log_client_doctor_number }}</td>
                    <td v-if="role_id == 1">{{ client_doctor_expired_number }}</td>
                    <td>{{ reservationing_number }}</td>
                    <td>{{ reservation_interrupt_number }}</td>
                    <td>{{ reservationed_number }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="table_message_box" v-if="role_id != 2">
            <p style="float: left">已签约特属专家列表</p>
            <span style="float: right;margin-left: 5px">
<!--				<el-button @click="addConsultant" v-if="role_id == 1">新增特属专家</el-button>-->
				<el-button type="primary" @click="importDoctorInfo" v-if="role_id==1 || role_id==3 || role_id == 21">导出签约特属专家</el-button>
			</span>
            <span style="float: right;">
                <el-date-picker
                    style="height: 40px;line-height: 40px;"
                    @change="searchClientDoctors"
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="签约日期"
                    end-placeholder="签约日期"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
            </span>
            <el-table ref="multipleTable" :data="allDoctor" border style="width: 100%">
                <el-table-column width="110" prop="doctor_name" label="特属专家姓名" align="center" label-class-name="label">
                    <template slot-scope="scope">
                        {{ scope.row.doctor_name.split('/')[0] }}
                    </template>
                </el-table-column>
                <el-table-column width="110" prop="doctor_mobile" label="联系电话" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="100" prop="hospital_nick_name" label="所属单位" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="department_name" label="所属科室" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="title_name" label="职称" align="center" label-class-name="label"></el-table-column>
                <el-table-column class-name="admin_user_name" width="200" prop="admin_user_name" label="特属服务专员"
                                 v-if="role_id != 2 && child_role_id == 0" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="100" prop="start_date" label="签约时间" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column width="110" prop="expired_txt" label="到期状态" align="center" label-class-name="label" v-if="role_id == 1">
                </el-table-column>
                <el-table-column width="100" prop="relation_id" label="聊天关系" align="center" label-class-name="label" v-if="role_id == 1">
                    <template slot-scope="scope">
                        {{ scope.row.relation_id ? '已建立' : '未建立' }}
                    </template>
                </el-table-column>
                <el-table-column width="120" prop="expired_date" label="协议到期时间" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="120" prop="pay_expired_date" label="缴费到期时间" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="70" prop="times" label="连续合约期数" align="center" label-class-name="label" v-if="role_id != 24"></el-table-column>
                <el-table-column width="140" prop="times" label="连续合约期数" align="center" label-class-name="label" v-if="role_id == 24"></el-table-column>
                <el-table-column width="80" label="状态" align="center" label-class-name="label" v-if="role_id != 24">
                    <template slot-scope="scope">
                        {{ role_id != 1 ? (scope.row.status == 1 ? '启用' : '停用') : (scope.row.is_unbind == 1 ? '已解约' : (scope.row.status == 1 ? '启用' : '停用')) }}
                    </template>
                </el-table-column>
                <el-table-column width="200" prop="address" label="操作" align="center" label-class-name="label" v-if="role_id != 24"
                                 v-slot="scope">
                    <template v-if="authCheck(scope.row)">
                        <el-button @click="editConsultant(scope.row)" type="text" size="small">
                            编辑
                        </el-button>
                        <el-button @click="goDoctorDetail(scope.row)" type="text" size="small">
                            特属专家详情
                        </el-button>
                        <el-button @click="editChatRelation(scope.row, 'unbind')" type="text" size="small"
                                   v-if="role_id==1 && scope.row.relation_id">
                            解除聊天关系
                        </el-button>
                        <el-button @click="editChatRelation(scope.row, 'create')" type="text" size="small"
                                   v-if="role_id==1 && !scope.row.relation_id">
                            建立聊天关系
                        </el-button>
                        <el-button @click="hospitalUnbinding(scope.row)" type="text" size="small"
                                   v-if="scope.row.is_unbind != 1">
                            解约
                        </el-button>
                    </template>

                </el-table-column>
            </el-table>
        </div>

        <div class="table_message_box">
            <p style="float: left">预约信息记录</p>
            <div class="search_data">
                <el-input @change="searchReservation" v-model="search_reservation_data" placeholder="搜索"/>
            </div>
            <el-table ref="multipleTable" :data="reservationListing" border style="width: 100%">
                <el-table-column prop="reservation_id" label="预约编号" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="doctor_name" label="特属专家" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="doctor_mobile" label="特属专家联系电话" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="status" label="预约状态" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="book_date" label="预约会面时间" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center" label-class-name="label"></el-table-column>
            </el-table>
            <el-pagination class="mg-20 ta-r" background layout="total, sizes, prev, pager, next, jumper"
                           :page-sizes="[5,10, 25, 50, 100]" :total="service_total" :page-size="service_perpage"
                           :current-page="service_page"
                           @current-change="serviceChangePage" @size-change="serviceChangeSite"></el-pagination>
            <span v-if="role_id != 24">
				<el-button @click="goReservationListing">查看更多预约信息</el-button>
			</span>
        </div>
        <div class="table_message_box" v-if="role_id != 2">
            <p style="float: left">联系人列表</p>
            <span style="float: right;">
				<el-button type="success" @click="addAssistant()">新增联系人</el-button>
			</span>
            <el-table ref="multipleTable" :data="allCustomer" border style="width: 100%">
                <!--				<el-table-column prop="user_id" label="ID" align="center" label-class-name="label"></el-table-column>-->
                <el-table-column prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="mobile" label="手机号码" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="status_name" label="状态" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="" label="操作" align="center" label-class-name="label" v-slot="scope">
                    <el-button @click="editAssistant(scope.row)" type="text" size="small">
                        编辑
                    </el-button>
                </el-table-column>
            </el-table>
        </div>


        <div class="table_message_box" v-if="role_id != 2">
            <p style="float: left">签约记录</p>
            <span style="float: right;" v-if="role_id != 24">
<!--				<el-button type="success" @click="addReservation(2)">新增续约</el-button>-->
				<el-button type="success" @click="addReservation(1)">新增签约</el-button>
			</span>
            <el-table ref="multipleTable" :data="allContract" border style="width: 100%">
                <el-table-column prop="doctor_name" label="签约特属专家" align="center" label-class-name="label">

                </el-table-column>
                <el-table-column label="类型" align="center" label-class-name="label">
                    <template slot-scope="scope">
                        {{ scope.row.contract_type == 2 ? '续约' : '新约' }}
                    </template>
                </el-table-column>
                <el-table-column prop="start_date" label="协议生效时间" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="expired_date" label="协议到期时间" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="contract_time" label="签约时间" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="status_name" label="缴费状态" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="amount" label="签约费用（元）" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="pay_year" label="缴费时长" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="pay_amount" label="已缴费用（元）" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="address" label="操作" align="center" label-class-name="label" v-slot="scope">
                    <el-button @click="editOneReservationDetail(scope.row)" type="text" v-if="role_id != 24"
                               size="small">
                        编辑
                    </el-button>
                    <el-button @click="oneReservationDetail(scope.row)" type="text" size="small">
                        协议详情
                    </el-button>
                    <el-button @click="editOneReservationDel(scope.row)" type="text" v-if="role_id != 24"
                               size="small">
                        删除
                    </el-button>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog :title="dialog_title" :visible.sync="dialogFormVisible">
            <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px"
                     class="form" style="width: 75%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="签约特属专家" required>
                    <el-autocomplete class="doctor_search"
                                     v-model="ruleForm.doctor_info"
                                     :fetch-suggestions="getDoctor"
                                     placeholder="请输入特属专家姓名关键词"
                                     @select="doctorSelect"
                    ></el-autocomplete>
                </el-form-item>

                <el-form-item label="特属服务专员" required>
                    <el-input type="text" :disabled="true" v-for="item in assistantList" :key="item.id"
                              :label="item.user_name" :value="item.user_name + '('+item.mobile+')'">
                    </el-input>
                </el-form-item>
                <el-form-item label="协议编号">
                    <el-input type="text" v-model="ruleForm.contract_title" placeholder="请输入协议编号" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="协议" :label-width="formLabelWidth">
                    <el-upload ref="upload" class="upload-demo" accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG,.pdf,.PDF"
                               :action="upload_agreement_path" :file-list="fileList"
                               :on-success="handleSuccess" :before-upload="beforeAvatarUpload" list-type="picture"
                               :multiple="true" :limit="9">
                        <div slot="file" slot-scope="{file}">
                            <pdf class="el-upload-list__item-thumbnail" v-if="file.name.endsWith('.pdf')"
                                 :src="file.url"></pdf>
                            <img v-else class="el-upload-list__item-thumbnail" :src="file.url" alt=""/>
                            <a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{ file.name }}</a>
                            <label class="el-upload-list__item-status-label">
                                <i class="el-icon-upload-success el-icon-check"></i>
                            </label>
                            <i class="el-icon-close" @click="handleRemoveFile(file)"></i>
                            <i class="el-icon-close-tip">按 delete 键可删除</i>
                        </div>

                        <el-button class="upload_btn" size="small" type="primary" v-if="addFileList.length < 9">点击上传
                        </el-button>
                        <div slot="tip" class="el-upload__tip" v-if="addFileList.length < 9">
                            注：请上传小于20M的图片，格式支持PNG,JPG,PDF
                        </div>
                    </el-upload>

                    <div class="upload-demo">
                        <el-button class="file_view" size="small" type="primary"
                                   @click="oneReservationDetail({contract_file: JSON.stringify(addFileList)})">预览协议
                        </el-button>
                    </div>

                </el-form-item>

                <el-form-item label="签约日期" prop="start_date">
                    <el-date-picker v-model="ruleForm.start_date" type="date" placeholder="选择日期" format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd" @change="getExpiredDate(ruleForm.is_expired)">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="签约年限" prop="year" v-if="ruleForm.is_expired == 1">
                    <el-select v-model="ruleForm.year" placeholder="请选择签约年限" style="width: 100%;"
                               @change="getExpiredDate(ruleForm.is_expired)">
                        <el-option v-for="item in allYear" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="续约年限" prop="year" v-if="ruleForm.is_expired == 2">
                    <el-select v-model="ruleForm.year" placeholder="请选择签约年限" style="width: 100%;"
                               @change="getExpiredDate(ruleForm.is_expired)">
                        <el-option v-for="item in allYear" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="到期时间">
                    <el-input type="text" v-model="ruleForm.expired_date" :disabled="true" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="签约金额（元）" prop="amount" v-if="ruleForm.start_date && ruleForm.year">
                    <el-input type="text" v-model="ruleForm.amount" :min="0" :disabled="true" placeholder="请输入签约金额"
                              autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="特属服务对象是否缴费" prop="status" v-if="ruleForm.start_date && ruleForm.year">
                    <el-radio-group v-model="ruleForm.status">
                        <el-radio label="1">否</el-radio>
                        <el-radio label="2">是</el-radio>
                        <el-radio label="3">赠送</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="缴费时长" prop="pay_year" v-if="ruleForm.status == 2">
                    <el-select v-model="ruleForm.pay_year" placeholder="请选择缴费时长" style="width: 100%;"
                               @change="payChange">
                        <el-option v-for="item in payAllYear" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="已缴费用（元）" v-if="ruleForm.status == 2">
                    <el-input type="text" v-model="ruleForm.pay_amount" :disabled="true" @input="amountCheck"
                              placeholder="请输入签约金额" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="协议类型" prop="status">
                    <el-radio-group v-model="ruleForm.is_expired">
                        <el-radio label="1" disabled>新增</el-radio>
                        <el-radio label="2" disabled>续约</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="变更说明" prop="remark" v-if="isedit">
                    <el-input type="textarea" v-model="ruleForm.remark" placeholder="请输入变更说明" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addReservationData">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="assistant_title" :visible.sync="addAssistantDialog">
            <el-form label-position="right" :model="assistantForm" :rules="assistantRules" ref="assistantForm"
                     label-width="150px"
                     class="form" style="width: 80%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="联系人姓名" prop="user_name">
                    <el-input type="text" v-model="assistantForm.user_name" placeholder="请输入联系人姓名" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="mobile">
                    <el-input type="text" v-model="assistantForm.mobile" placeholder="请输入联系人手机号码" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="assistantForm.status">
                        <el-radio label="1">启用</el-radio>
                        <el-radio label="2">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否设为子账号" prop="status" v-if="assistant_edit">
                    <el-radio-group v-model="assistantForm.is_main">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="头像" prop="user_avatar" v-if="assistant_edit &&  assistantForm.is_main == 1">
                    <div class="avatar-uploader">
                        <label class="avatar-btn" for="uploads">
                            <img style=" width: 200px;height: 200px;" v-if="userAvaratImageUrl"
                                 :src="userAvaratImageUrl"
                                 class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </label>
                    </div>
                    <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                           accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addAssistantDialog = false">取 消</el-button>
                <el-button type="primary" @click="addAssistantData">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="协议详情" :visible.sync="dialogContractFormVisible">
            <el-carousel indicator-position="outside" height="700px" :autoplay="false">
                <el-carousel-item v-for="(url, n) in allContractUrls" :key="n">
                    <div class="image_box" v-if="getFileType(url.src) == 'pdf'">
                        <pdf
                            v-for="i in url.pages"
                            :key="i"
                            :page="i"
                            :src="url.src"></pdf>
                    </div>
                    <div class="image_box" v-if="getFileType(url.src) != 'pdf'">
                        <el-image :src="url.src"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>

        <el-dialog :title="dialog_consultant_title" :visible.sync="dialogConsultantFormVisible"
                   @close="closeConsultant">
            <el-form label-position="right" :model="consultantForm" :rules="rules" ref="consultantForm"
                     label-width="150px" class="form" style="width: 80%;margin: 20px auto 0 auto;" autocomplete="off">

                <el-form-item label="签约特属专家" v-if="isAdd == 1">
                    <el-autocomplete class="doctor_search"
                                     v-model="consultantForm.doctor_info"
                                     :fetch-suggestions="getDoctor"
                                     placeholder="请输入特属专家姓名关键词"
                                     :trigger-on-focus="trigger_on_focus"
                                     @select="doctorAddSelect"
                    ></el-autocomplete>
                </el-form-item>
                <el-form-item label="签约特属专家" v-if="isAdd != 1">
                    <el-input type="text" v-model="consultantForm.doctor_info" placeholder="请输入特属专家姓名关键词"
                              autocomplete="off"
                              style="width: 100%;" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="签约时间" prop="start_date">
                    <el-date-picker v-model="consultantForm.start_date" type="date" placeholder="请选择日期"
                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="服务截止日期" prop="expired_date">
                    <el-date-picker v-model="consultantForm.expired_date" type="date" placeholder="请选择日期"
                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="到期状态" prop="status" v-if="role_id == 1 && isedit">
                    <el-radio-group v-model="consultantForm.is_expired">
                        <el-radio label="1">已到期</el-radio>
                        <el-radio label="2">生效中</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogConsultantFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addConsultantData">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="头像裁剪" :visible.sync="dialogVisible" append-to-body @close="closeDialog">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :autoCrop="true"
                        :fixed="true"
                        :fixedNumber="[1, 1]">
                    </vue-cropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <label class="el-button el-button--primary" for="suploads" style="margin-right: 10px;"><span>重新选择</span></label>
                <input type="file" id="suploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                <el-button type="primary" @click="uploadImg('blob')" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import Box from "@/components/Box.vue";
import {
    check
} from "@/utils/checkData";
import {VueCropper} from "vue-cropper";
import {authUrlCheck, base64Parser, fileType, getBase64Image, isMobile, loadFile} from "@/api/order";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import {saveAs} from "file-saver";
import ImageModule from "docxtemplater-image-module-free";
import pdf from 'vue-pdf'
import {getUserInfos} from "@/utils/userInfos";

export default {
    components: {
        Box,
        VueCropper,
        pdf,
    },
    data() {
        return {
            role_id: 0, // 角色类型
            child_role_id: 0, // 角色类型
            base_admin_user_name: '',
            base_admin_user_mobile: '',
            restaurants: [],
            allManager: [],
            allCompanys: [],
            allDepartments: [],
            allGroups: [],
            allDoctorsWithDocument: [],
            allContractUrls: [],
            editId: '',
            isAdd: 1, // 1：添加；0：编辑;
            isShowVoucherImg: 0,
            isAddClientContractDoctor: 1, // 1：添加；2编辑；
            is_offline: 0,
            dialogFormVisible: false,
            dialogConsultantFormVisible: false,
            dialogContractFormVisible: false,
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            dialog_title: '新增签约',
            dialog_consultant_title: '新签约特属专家',
            userVoucherImgUrl: '',
            user_id: '',
            offlineDisabled: false,
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            upload_agreement_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=99',
            fileList: [],
            addFileList: [],
            search_reservation_data: '',
            user_avatar: '',
            user_name: '',
            status: '',
            bloc_name: '',
            idcard: '',
            manager_name: '',
            mobile: '',
            posistion: '',
            start_date: '',
            expired_date: '',
            pay_expired_date: '',
            is_expired: '',
            assistant_name: '',
            assistant_mobile: '',
            nick_name: '',
            doctor_name: '',
            client_doctor_number: 0, // 当前签约生效特属专家数
            client_doctor_expired_number: 0, // 签约到期特属专家数
            client_doctor_will_number: 0, // 签约待生效特属专家数
            user_assistant_number: 0,
            health_records_number: 0,
            all_log_client_doctor_number: 0, // 历史签约特属专家数
            reservationing_number: 0,
            reservation_interrupt_number: 0,
            reservationed_number: 0,
            service_total: 0,
            service_perpage: 5,
            service_page: 1,
            allAddClientContractDoctor: [],
            allDoctor: [], // 已签医生列表
            allCustomer: [], // 子账户列表
            allContract: [], // 签约记录
            doctors: [], //平台所有特属专家-剔除已签约的
            use_doctors: [], // 平台可签约特属专家
            assistantList: [], //签约特属专家的绑定健康管理助理
            search_expired_date: [],
            search_key: '',
            search_doctors: [],
            reservationListing: [],
            isedit: false,
            addAssistantDialog: false,
            assistant_title: '添加联系人',
            assistant_edit: false,
            userAvaratImageUrl: '',
            ruleForm: {
                file: "",
                year: '',
                start_date: '',
                amount: '',
                pay_amount: '', // 已缴费用：自动计算出
                pay_year: '', // 缴费时长
                doctor_list: '',
                voucher_img: '',
                is_offline: 1,
                doctor_name: '',
                doctor_id: '',
                contract_type: '1',
                status: "2",
                remark: '',
                doctor_info: '',
                is_expired: "1",
                expired_date: "",
                old_expired_date: "",
                contract_title: "",
            },
            consultantForm: {
                expired_date: '',
                doctor_id: '',
                hospital_id: '',
                department_id: '',
                start_date: '',
                doctor_info: '',
                is_expired: "2",
            },
            assistantForm: {
                user_id: '',
                user_name: "",
                mobile: "",
                client_id: "",
                status: '1',
                is_main: '2',
                user_avatar: "",
            },
            assistantRules: {
                user_name: [
                    {required: true, message: "请输入特属服务对象姓名", trigger: "blur"},
                ],
                mobile: [
                    {required: true, message: "请输入手机号码", trigger: "blur"},
                ],
                status: [
                    {required: true, message: "请选择状态", trigger: "blur"},
                ],
            },
            rules: {
                file: [{
                    required: true,
                    message: "请上传协议",
                    trigger: "blur"
                },],
                year: [{
                    required: true,
                    message: "请选择年限",
                    trigger: "blur"
                },],
                pay_year: [{
                    required: true,
                    message: "请选择缴费时长",
                    trigger: "blur"
                },],
                start_date: [{
                    required: true,
                    message: "请选择签约日期",
                    trigger: "blur"
                },],
                expired_date: [{
                    required: true,
                    message: "请选择截止日期",
                    trigger: "blur"
                },],
                amount: [{
                    required: true,
                    message: "请输入签约金额",
                    trigger: "blur"
                },],
                doctor_id: [{
                    required: true,
                    message: "请选择特属专家",
                    trigger: "blur"
                },],
                doctor_info: [{
                    required: true,
                    message: "请输入特属专家名称",
                    trigger: "blur"
                },],
            },
            allYear: [
                {
                    id: 1,
                    name: '一年'
                },
                {
                    id: 2,
                    name: '二年'
                },
                // {
                //     id: 3,
                //     name: '三年'
                // },
                // {
                //     id: 4,
                //     name: '四年'
                // }
            ],
            payAllYear: [
                {
                    id: 1,
                    name: '一年'
                },
                {
                    id: 2,
                    name: '二年'
                }
            ],
            formLabelWidth: '180px',
            trigger_on_focus: true,

            dialogVisible: false,
            // 防止重复提交
            loading: false,
            service_fee: 0, // 每年的服务费
            option: {
                img: '',             //裁剪图片的地址
            },
            is_submit: false,
            is_mobile: false,
        };
    },
    created() {
        localStorage.setItem('prev_page', 'user_detail')
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
            this.child_role_id = parseInt(userInfo.child_role_id)
        }
        this.user_id = this.$route.params.user_id || this.$route.query.user_id;
        this.userDetail();
        this.reservationListingMethod();
        this.getAllCompanys();
        this.getServiceFee()
    },
    mounted() {
        if (isMobile()) {
            this.is_mobile = true
        }
    },
    methods: {
        amountCheck(e) {
            if (e < 0) {
                this.$message({
                    message: '签约金额不能小于0',
                    type: 'error'
                });
                this.ruleForm.amount = 0;
                return;
            }
            if (!e || isNaN(e)) {
                this.ruleForm.amount = 0;
            } else {
                this.ruleForm.amount = parseInt(e);
            }
        },
        payChange(e) {
            let year = e;
            if (e > this.ruleForm.year) {
                this.ruleForm.pay_year = this.ruleForm.year
                year = this.ruleForm.year
            }
            this.ruleForm.pay_amount = (year * (this.ruleForm.amount / this.ruleForm.year)).toFixed(2)
        },
        getServiceFee() {
            let params = {
                servername: 'Ruyi_AdminSystemServices',
                method: 'getServiceFee',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.service_fee = res.data.data.service_fee
            });
        },
        // 获取医生详情资料
        userDetail() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'userDetail',
                params: {
                    user_id: this.user_id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.user_name = res.data.data.user_detail.user_name;
                let user_detali = res.data.data.user_detail;
                switch (res.data.data.user_detail.status) {
                    case '1':
                        this.status = '启用';
                        break;
                    case '2':
                        this.status = '停用';
                        break;
                }
                if (user_detali.user_avatar) {
                    this.user_avatar = this.imgUrl + user_detali.user_avatar;
                }

                this.bloc_name = user_detali.bloc_name;
                this.idcard = user_detali.idcard;
                this.manager_name = user_detali.manager_name;
                this.mobile = user_detali.mobile;
                switch (user_detali.is_expired) {
                    case '1':
                        this.is_expired = '未缴纳';
                        break;
                    case '2':
                        this.is_expired = '已缴纳';
                        break;
                }
                this.expired_date = user_detali.expired_date;
                this.pay_expired_date = user_detali.pay_expired_date;
                if (this.role_id == 1) {
                    this.client_doctor_expired_number = user_detali.client_doctor_expired_number
                    this.client_doctor_will_number = user_detali.client_doctor_will_number
                    // this.client_doctor_number = user_detali.client_doctor_number - user_detali.client_doctor_expired_number - user_detali.client_doctor_will_number;
                    this.client_doctor_number = user_detali.client_doctor_effective_number;
                } else {
                    this.client_doctor_number = user_detali.client_doctor_number;
                }

                this.user_assistant_number = user_detali.user_assistant_number;
                this.health_records_number = user_detali.health_records_number;
                this.posistion = user_detali.posistion;
                this.nick_name = user_detali.nick_name;
                this.assistant_name = user_detali.assistant_name;
                this.assistant_mobile = user_detali.assistant_mobile;
                this.base_admin_user_mobile = user_detali.base_admin_user_mobile;
                this.base_admin_user_name = user_detali.base_admin_user_name;


                this.nick_name = user_detali.nick_name;
                this.all_log_client_doctor_number = res.data.data.all_log_client_doctor_number;
                this.reservationing_number = res.data.data.reservationing_number;
                this.reservation_interrupt_number = res.data.data.reservation_interrupt_number;
                this.reservationed_number = res.data.data.reservationed_number;
                this.allManager = res.data.data.user_doctor_manager;
                this.allDoctor = [];
                let client_doctor = res.data.data.user_client_doctor;
                for (var i = 0; i < client_doctor.length; i++) {
                    //if (res.data.data.user_client_doctor[i].is_expired == 2) {
                    client_doctor[i].doctor_name = client_doctor[i].doctor_name + '/' + client_doctor[i].hospital_name

                    this.allDoctor.push(client_doctor[i]);
                    //}
                }
                this.getAllDoctors();
                //this.allDoctor = res.data.data.user_client_doctor;
                for (var i = 0; i < res.data.data.user_assistant.length; i++) {
                    switch (res.data.data.user_assistant[i].status) {
                        case '1':
                            res.data.data.user_assistant[i].status_name = '启用';
                            break;
                        case '2':
                            res.data.data.user_assistant[i].status_name = '停用';
                            break;
                    }
                }
                this.allCustomer = res.data.data.user_assistant;
                for (var i = 0; i < this.allCustomer.length; i++) {
                    this.allCustomer[i].no = i + 1;
                }
                for (var i = 0; i < res.data.data.user_client_contract.length; i++) {
                    switch (res.data.data.user_client_contract[i].status) {
                        case '1':
                            res.data.data.user_client_contract[i].status_name = '未缴纳';
                            break;
                        case '2':
                            res.data.data.user_client_contract[i].status_name = '已缴纳';
                            res.data.data.user_client_contract[i].pay_amount = res.data.data.user_client_contract[i].pay_year * (res.data.data.user_client_contract[i].amount / res.data.data.user_client_contract[i].year)
                            res.data.data.user_client_contract[i].pay_amount = res.data.data.user_client_contract[i].pay_amount.toFixed(2)
                            break;
                        case '3':
                            res.data.data.user_client_contract[i].status_name = '已缴纳';
                            res.data.data.user_client_contract[i].pay_amount = res.data.data.user_client_contract[i].pay_year * (res.data.data.user_client_contract[i].amount / res.data.data.user_client_contract[i].year)
                            res.data.data.user_client_contract[i].pay_amount =res.data.data.user_client_contract[i].pay_amount.toFixed(2) + '(赠送)'
                            break;
                    }
                    if (res.data.data.user_client_contract[i].pay_year > 0) {
                        res.data.data.user_client_contract[i].pay_year_number = res.data.data.user_client_contract[i].pay_year
                        res.data.data.user_client_contract[i].pay_year = res.data.data.user_client_contract[i].pay_year + '年'
                    }
                }
                this.allContract = res.data.data.user_client_contract;
            });
        },

        // 预约信息列表
        reservationListingMethod() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'userClientContractList',
                params: {
                    user_id: this.user_id,
                    search_reservation_data: this.search_reservation_data,
                },
                pageinfo: {
                    page: this.service_page,
                    perpage: this.service_perpage,
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }

                for (var i = 0; i < res.data.data.list.length; i++) {
                    switch (res.data.data.list[i].status) {
                        case '1':
                            res.data.data.list[i].status = '预约处理';
                            break;
                        case '2':
                            res.data.data.list[i].status = '等待会面';
                            break;
                        case '3':
                            res.data.data.list[i].status = '会面完成';
                            break;
                        case '4':
                            res.data.data.list[i].status = '会面中断';
                            break;
                    }
                }

                this.reservationListing = res.data.data.list;
                this.service_total = res.data.data.page.count;
                this.is_submit = false;
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        // 返回上一页
        goBack() {
            window.history.go(-1);
            return;
        },

        serviceChangePage(index) {
            this.service_page = index;
            this.reservationListingMethod();
        },

        serviceChangeSite(index) {
            this.service_perpage = index;
            this.reservationListingMethod();
        },

        // 跳转编辑
        edit() {
            this.$router.replace({
                name: "userEdit",
                params: {
                    user_id: this.user_id
                }
            });
        },

        // 搜索预约信息
        searchReservation() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.service_page = 1;
            this.reservationListingMethod();
        },

        // 查看更多预约
        goReservationListing() {
            this.$router.push({
                name: "workList",
                params: {user_name: this.user_name}
            });
        },

        // 打开添加预约弹窗
        addReservation(type) {
            this.isedit = false;
            this.dialog_title = type == 1 ? '新增签约' : '新增续签';
            this.isAdd = 1;
            this.isShowVoucherImg = 0;
            this.fileList = [];
            this.addFileList = [];
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
            }
            if (type == 1) {
                //新增签约
                this.use_doctors = this.doctors
            } else {
                //新增续约
                this.use_doctors = this.allDoctor
            }

            this.ruleForm.file = '';
            this.ruleForm.doctor_name = '';
            this.ruleForm.year = '';
            this.ruleForm.start_date = '';
            this.ruleForm.amount = '';
            this.ruleForm.pay_amount = '';
            this.ruleForm.pay_year = '';
            this.ruleForm.contract_title = '';
            this.ruleForm.contract_type = type;
            this.ruleForm.doctor_list = '';
            //this.ruleForm.voucher_img = '';
            this.userVoucherImgUrl = '';
            this.ruleForm.is_offline = 1;
            this.ruleForm.status = 1;
            this.editId = '';
            this.ruleForm.doctor_info = '';
            this.search_key = '';
            this.assistantList = [];
            this.ruleForm.remark = '';
            this.ruleForm.status = this.ruleForm.status.toString()
            this.ruleForm.expired_date = '';
            this.ruleForm.old_expired_date = '';

            this.$nextTick(() => {
                this.dialogFormVisible = true;
            });
        },
        addAssistant() {
            this.assistant_edit = false;
            this.assistant_title = '添加联系人';
            this.addAssistantDialog = true;
            this.assistantForm.client_id = '';
            this.assistantForm.user_id = '';
            this.assistantForm.user_name = '';
            this.assistantForm.mobile = '';
            this.assistantForm.status = '';
            this.assistantForm.user_avatar = '';
            this.userAvaratImageUrl = '';
        },
        editAssistant(data) {
            this.assistant_edit = true;
            this.assistant_title = '编辑联系人';
            this.addAssistantDialog = true;
            this.assistantForm.client_id = this.user_id;
            this.assistantForm.user_id = data.user_id;
            this.assistantForm.user_name = data.user_name;
            this.assistantForm.mobile = data.mobile;
            this.assistantForm.status = data.status;
            this.assistantForm.is_main = data.is_main.toString();
            this.assistantForm.user_avatar = data.user_avatar;
            if (data.user_avatar != null && data.user_avatar != "")
                this.userAvaratImageUrl = this.imgUrl + data.user_avatar;

        },
        addAssistantData() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.$refs['assistantForm'].validate(valid => {
                if (valid) {
                    this.assistantForm.client_id = this.user_id;
                    let params = {
                        'servername': 'Ruyi_AdminCustomerServices',
                        'method': this.assistantForm.user_id == '' ? 'createUserAssistan' : 'editUserAssistant',
                        'params': this.assistantForm
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: this.assistantForm.user_id == '' ? '创建成功' : '修改成功',
                            duration: 1500,
                        });
                    }).finally(() => {
                        this.is_submit = false;
                    });
                    this.is_submit = false;
                    this.addAssistantDialog = false;
                    this.userDetail();
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },

        // 打开添加特属专家弹窗
        addConsultant() {

            this.isedit = false;
            this.dialog_consultant_title = '新增特属专家';
            this.isAdd = 1;

            this.consultantForm.expired_date = '';
            this.consultantForm.doctor_list = '';
            this.consultantForm.hospital_id = "";
            this.consultantForm.department_id = "";
            this.consultantForm.doctor_id = '';
            this.consultantForm.start_date = '';
            this.editId = '';
            this.allDepartments = [];
            this.allDoctorsWithDocument = [];

            this.dialogConsultantFormVisible = true;

        },


        editConsultant(data) {
            this.isedit = true;
            this.dialog_consultant_title = '修改签约特属专家';
            this.isAdd = 0;

            this.editId = data.id;

            this.$nextTick(() => {

                //this.ruleForm.doctor_list = data.doctor_list.split(',');
                if (data.doctor_id) {
                    this.consultantForm.doctor_info = data.doctor_name + '/' + data.department_name
                } else {
                    this.consultantForm.doctor_info = data.doctor_name
                }

                this.consultantForm.doctor_id = data.doctor_id;
                this.consultantForm.expired_date = data.expired_date;
                this.consultantForm.hospital_id = data.hospital_id;
                this.consultantForm.department_id = data.department_id;
                this.consultantForm.start_date = data.start_date;
                this.consultantForm.is_expired = data.is_expired;

                this.dialogConsultantFormVisible = true;

                this.changeDoctor()
            })


        },


        // 打开编辑弹框
        editOneReservationDetail(data) {
            this.isedit = true;
            this.dialog_title = '编辑签约';
            this.editId = data.id;
            this.isAdd = 0;
            this.fileList = [];
            this.addFileList = [];
            this.ruleForm.file = '';
            this.ruleForm.year = '';
            this.ruleForm.doctor_name = '';
            this.ruleForm.start_date = '';
            this.ruleForm.amount = '';
            this.ruleForm.doctor_list = '';
            this.ruleForm.voucher_img = '';
            this.userVoucherImgUrl = '';
            this.ruleForm.is_offline = 1;
            this.isShowVoucherImg = 0;
            this.ruleForm.expired_date = '';
            this.ruleForm.old_expired_date = '';
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
            }

            var allFile = [];
            if (data.contract_file && data.contract_file != '' && data.contract_file != null) {
                var contract_file = JSON.parse(data.contract_file);
                if (contract_file.length == 0) {
                    this.addFileList = [];
                    this.fileList = [];
                } else {
                    this.addFileList = contract_file;

                    for (var i = 0; i < contract_file.length; i++) {
                        let index = contract_file[i].file.lastIndexOf("/");
                        let name = contract_file[i].file.substring(index + 1, contract_file[i].file.length);
                        let oneContract = {
                            name: name,
                            url: this.imgUrl + contract_file[i].file,
                            x: contract_file[i].x,
                            y: contract_file[i].y,
                        };
                        allFile.push(oneContract);
                        this.ruleForm.file = "file";
                    }
                }
            }

            this.fileList = allFile;


            // 渲染图片成功之后
            this.$nextTick(() => {

                //this.ruleForm.doctor_list = data.doctor_list.split(',');
                if (data.doctor_id) {
                    this.ruleForm.doctor_info = data.doctor_name + '/' + data.hospital_name + '/' + data.department_name
                } else {
                    this.ruleForm.doctor_info = data.doctor_name
                }

                this.ruleForm.doctor_id = data.doctor_id;
                this.ruleForm.doctor_name = data.doctor_name;
                this.ruleForm.year = parseInt(data.year);
                this.ruleForm.pay_year = parseInt(data.pay_year);
                if (data.status == 2) {
                    this.ruleForm.pay_amount = (data.pay_year_number * (data.amount / data.year)).toFixed(2)
                }

                this.ruleForm.remark = data.remark
                this.ruleForm.amount = data.amount;
                this.ruleForm.contract_title = data.contract_title;
                // this.ruleForm.start_date = data.start_date;
                this.ruleForm.start_date = data.contract_time; // 签约日期
                this.ruleForm.status = data.status.toString();
                //this.ruleForm.is_offline = data.is_offline
                this.ruleForm.contract_type = data.contract_type
                this.dialogFormVisible = true;

                this.ruleForm.is_expired = data.contract_type.toString()
                this.ruleForm.expired_date = data.expired_date;
                this.ruleForm.old_expired_date = data.start_date;

                this.changeDoctor()
            })
        },


        // 调用接口，添加预约或编辑预约
        addReservationData() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    if (this.isAdd == 1) {
                        // 新增预约
                        let params = {
                            servername: 'Ruyi_AdminCustomerServices',
                            method: 'createUserClientContract',
                            params: {
                                user_id: this.user_id,
                                //doctor_list: this.ruleForm.doctor_list,
                                doctor_name: this.ruleForm.doctor_name,
                                user_name: this.user_name,
                                doctor_id: this.ruleForm.doctor_id,
                                contract_file: this.addFileList,
                                year: this.ruleForm.year,
                                pay_year: this.ruleForm.pay_year,
                                start_date: this.ruleForm.start_date,
                                amount: this.ruleForm.amount,
                                status: this.ruleForm.status,
                                remark: this.ruleForm.remark,
                                contract_title: this.ruleForm.contract_title,
                                contract_type: this.ruleForm.contract_type
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            if (res.data.code != '0') {
                                this.$message({
                                    type: "error",
                                    message: res.data.msg,
                                    duration: 1500,
                                });
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '新增成功',
                                duration: 1500
                            });
                            this.dialogFormVisible = false;
                            this.is_submit = false;
                            this.userDetail();
                        }).catch(() => {
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        // 编辑预约
                        let params = {
                            servername: 'Ruyi_AdminCustomerServices',
                            method: 'editUserClientContract',
                            params: {
                                id: this.editId,
                                user_id: this.user_id,
                                doctor_name: this.ruleForm.doctor_name,
                                user_name: this.user_name,
                                doctor_id: this.ruleForm.doctor_id,
                                contract_file: this.addFileList,
                                year: this.ruleForm.year,
                                pay_year: this.ruleForm.pay_year,
                                start_date: this.ruleForm.start_date,
                                amount: this.ruleForm.amount,
                                status: this.ruleForm.status,
                                remark: this.ruleForm.remark,
                                contract_type: this.ruleForm.contract_type,
                                contract_title: this.ruleForm.contract_title
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            if (res.data.code != '0') {
                                this.$message({
                                    type: "error",
                                    message: res.data.msg,
                                    duration: 1500,
                                });
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                                duration: 1500
                            });
                            this.dialogFormVisible = false;
                            this.is_submit = false;
                            this.userDetail();
                        }).catch(() => {
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });

                    }
                } else {
                    this.is_submit = false;
                }
            })

        },

        // 调用接口，添加特属专家或编辑特属专家
        addConsultantData() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.$refs["consultantForm"].validate(valid => {

                if (valid) {
                    // 新增预约
                    let params = {
                        servername: 'Ruyi_AdminCustomerServices',
                        method: 'bindUserConsultant',
                        params: {
                            id: this.editId,
                            user_id: this.user_id,
                            doctor_id: this.consultantForm.doctor_id,
                            expired_date: this.consultantForm.expired_date,
                            start_date: this.consultantForm.start_date,
                            is_expired: this.editId > 0 ? this.consultantForm.is_expired : '',
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '操作成功',
                            duration: 1500
                        });
                        this.dialogConsultantFormVisible = false;
                        this.userDetail();
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.is_submit = false;
                }
            })

        },

        // 除去图片
        handleRemoveFile(file) {
            this.$refs.upload.handleRemove(file)
            for (let i = 0; i < this.addFileList.length; i++) {
                if ((file.response && file.response.data.file == this.addFileList[i].file) || (file.url && file.url.indexOf(this.addFileList[i].file) > -1)) {
                    this.addFileList.splice(i, 1);
                }
            }
        },

        // 上传图片成功
        handleSuccess(response, file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        let obj = {
                            file: name,
                            x: fileList[i].x,
                            y: fileList[i].y,
                        };
                        addFileList.push(obj);
                    }
                }
            }
            this.addFileList = addFileList;
            this.ruleForm.file = "file";
        },

        // 协议详情
        async oneReservationDetail(data) {

            this.allContractUrls = [];
            let allContractUrls = [];
            if (data.contract_file) {
                let contract_file = JSON.parse(data.contract_file);
                let url = '';
                let local_url = '';
                let num_pages = 0;
                if (contract_file.length > 0) {
                    for (let i = 0; i < contract_file.length; i++) {
                        local_url = url = this.imgUrl + contract_file[i].file;
                        num_pages = 0;
                        if (this.getFileType(url) == 'pdf') {
                            url = pdf.createLoadingTask(url)
                            await url.promise.then(pdf => {
                                num_pages = pdf.numPages
                                allContractUrls.push({
                                    src: local_url,
                                    pages: num_pages
                                });
                            });

                        } else {
                            allContractUrls.push({
                                src: local_url,
                                pages: num_pages
                            });
                        }
                    }
                }
            }
            this.allContractUrls = allContractUrls;
            this.dialogContractFormVisible = true;
        },
        getFileType(url) {
            return fileType(url)
        },
        // 聊天关系处理
        editChatRelation(data, type) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            let doctor_name = data.doctor_name.split('/')[0]
            this.is_submit = true;
            this.$confirm(`确定要解除与 "${doctor_name}" 的聊天关系吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'editChatRelation',
                    params: {
                        doctor_id: data.doctor_id,
                        user_id: data.user_id,
                        type: type,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                            duration: 1500,
                        });
                    } else {
                        this.$message({
                            type: "success",
                            message: '处理成功',
                            duration: 1500,
                        });
                    }
                    this.is_submit = false;
                    this.userDetail();
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        // 跳转特属专家详情
        goDoctorDetail(data) {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/doctor/DoctorDetail', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.replace({
                name: "doctorDetail",
                params: {
                    user_id: data.doctor_id
                }
            });
            return;

        },
        editOneReservationDel(data) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.$confirm('确定删除该协议吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'delUserClientContract',
                    params: {
                        id: data.id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                            duration: 1500,
                        });
                    } else {
                        this.$message({
                            type: "success",
                            message: '删除成功',
                            duration: 1500,
                        });
                    }
                    this.is_submit = false;
                    this.userDetail();
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        //  切换是否线下缴费
        /*changeIsOffline() {
            if (this.ruleForm.is_offline == 2) {
                this.isShowVoucherImg = 1;
            } else {
                this.isShowVoucherImg = 0;
            }
        },*/

        handleAssiAvatarImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.voucher_img = res.data;
                this.userAvaratImageUrl = res.data;
                this.assistantForm.user_avatar = res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 上传身份证正面图片
        handleUserAvatarImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.voucher_img = res.data;
                this.userVoucherImgUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },


        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 20;
            if (!isJPG) {
                this.$message.error('协议文件只能是jpg/png/pdf格式!');
            }
            if (!isLt5M) {
                isJPG = false;
                this.$message.error('协议文件大小不能超过20MB!');

            }
            return isJPG;
        },
        goAssistan() {
            this.$router.push({
                name: "assistantList",
                query: {
                    user_name: this.user_name
                }
            });
            //跳转到子帐户列表页

        },
        goHealthRecord() {
            this.$router.push({
                name: "healthrecordsList",
                params: {user_name: this.user_name}
            });
            //跳转到子帐户列表页

        },
        goManagerDetail(data) {
            this.$router.push({
                name: "managerDetail",
                params: {
                    user_id: data.user_id,
                    user_name: data.user_name,
                    mobile: data.mobile,
                    company_name: data.company_name,
                    company_department_name: data.department_name,
                    company_group_name: data.group_name,
                    status: data.status,
                }
            });
        },


        //获取全部单位
        getAllCompanys() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllHospitals',
                params: {}
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompanys = res.data.data.hospital;
            });
        },

        //获取单位下的医生
        updateDoctors(id) {
            var hospital_id = id;
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllDepartmentsWithHospital',
                params: {
                    hospital_id: hospital_id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allDepartments = res.data.data.department;
            });
        },

        //获取部门下的特属专家
        updateDoctor(id) {
            var department_id = id;
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'getAllDoctorWithDepartment',
                params: {
                    hospital_department_id: department_id,
                    doctor_id: this.consultantForm.doctor_id,
                    user_id: this.user_id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allDoctorsWithDocument = res.data.data.doctors;
            });
        },

        //解约
        hospitalUnbinding(data) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            let doctor_name = data.doctor_name.split('/')[0]
            this.is_submit = true;
            this.$confirm(`确定要解约特属专家：${doctor_name} ？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'unbindUserConsultant',
                    params: {
                        id: data.id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                            duration: 1500,
                        });
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '解约成功',
                        duration: 1500
                    });
                    //this.$router.go(0);
                    //this.dialogConsultantFormVisible = false;
                    this.is_submit = false;
                    this.userDetail();
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });

        },
        // 获取未与之签约的特属专家
        getAllDoctors() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'allDoctor',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    return;
                }

                let doctors = res.data.data;
                let len = doctors.length;
                // 剔除已签约特属专家
                for (var i = 0; i < len; i++) {
                    for (var j = 0; j < this.allDoctor.length; j++) {
                        if (doctors[i].user_id == this.allDoctor[j].user_id) {
                            break
                        }
                    }
                    if (j == this.allDoctor.length) {
                        this.use_doctors.push(doctors[i])
                    }
                }
                this.doctors = doctors;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        changeDoctor() {
            if (!this.ruleForm.doctor_id) return;
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'getAssistants',
                params: {
                    doctor_id: this.ruleForm.doctor_id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    return;
                }
                this.assistantList = res.data.data
            });
        },
        getUserClientDoctorInfo() {
            if (!this.ruleForm.doctor_id) return;
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'getClientDoctorInfo',
                params: {
                    doctor_id: this.ruleForm.doctor_id,
                    user_id: this.user_id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    return;
                }


                if (res.data.data) {
                    if (res.data.data.is_expired == 1) {
                        this.dialog_title = '新增签约'
                    } else {
                        this.dialog_title = '新增续约'
                        this.ruleForm.expired_date = res.data.data.expired_date;
                        this.ruleForm.old_expired_date = res.data.data.expired_date;
                    }

                    this.ruleForm.is_expired = res.data.data.is_expired.toString();

                } else {
                    this.ruleForm.is_expired = "1"
                    this.dialog_title = '新增签约'
                }

            });
        },

        getDoctor(key, cb) {
            if (key.indexOf('/') > -1) {
                this.prev_search = key.split('/')[0] || key.split('/')[1]
                key = this.prev_search
            }
            if (!key) {
                cb([{"value": "请输入特属专家姓名关键词"}]);
                return;
            }
            if (this.search_key == key) {
                cb(this.search_doctors);
                return;
            }
            this.search_key = key
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'searchDoctor',
                params: {
                    doctor_name: key,
                    user_client: 'yes',
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    return;
                }
                // this.use_doctors = res.data.data
                var doctors = res.data.data
                if (doctors) {
                    for (var i = 0; i < doctors.length; i++) {
                        doctors[i].value = doctors[i].user_name + '/' + doctors[i].hospital_name + '/' + doctors[i].department_name
                    }
                    this.search_doctors = doctors;
                    cb(doctors);
                } else {
                    cb([{"value": "没有找到特属专家"}]);
                }

            });

        },
        doctorSelect(item) {
            this.ruleForm.doctor_id = item.user_id;
            this.ruleForm.doctor_name = item.user_name;
            this.changeDoctor()
            this.getUserClientDoctorInfo()
        },
        doctorAddSelect(item) {
            this.consultantForm.doctor_id = item.user_id
        },
        closeConsultant() {
            this.consultantForm.doctor_info = '';
        },
        getExpiredDate(type) {
            let baseDate = ''

            if (type == 2) {
                baseDate = this.ruleForm.old_expired_date
            } else {
                if (!this.ruleForm.start_date) return
                baseDate = this.ruleForm.start_date
            }
            if (this.ruleForm.year == 1) {
                this.payAllYear = [
                    {
                        id: 1,
                        name: '一年'
                    }
                ];
                this.ruleForm.pay_year = 1
                if (this.ruleForm.start_date) {
                    // 计算服务费
                    this.ruleForm.amount = (this.ruleForm.year * this.service_fee).toFixed(2)
                }
                this.payChange(1)
            } else {
                this.payAllYear = [
                    {
                        id: 1,
                        name: '一年'
                    },
                    {
                        id: 2,
                        name: '二年'
                    }
                ];
            }
            let date = new Date(baseDate)
            let y = date.getFullYear() + this.ruleForm.year;
            let m = date.getMonth() + 1;
            let d = date.getDate()
            this.ruleForm.expired_date = `${y}-${m}-${d}`

            if (this.ruleForm.year > 0 && this.ruleForm.start_date) {
                // 计算服务费
                this.ruleForm.amount = (this.ruleForm.year * this.service_fee).toFixed(2)
            }
        },
        //选择图片
        selectImg(e) {
            let file = e.target.files[0]

            if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                this.$message({
                    message: '图片类型要求：jpeg、jpg、png',
                    type: "error"
                });
                return false
            }
            //转化为blob
            let reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                this.option.img = data
                this.dialogVisible = true;
            }
            //转化为base64
            reader.readAsDataURL(file)
        },
        //上传图片
        uploadImg(type) {
            let _this = this;
            if (type === 'blob') {
                //获取截图的blob数据
                this.$refs.cropper.getCropBlob(async (data) => {

                    let formData = new FormData();
                    formData.append('file', data, ".jpg")

                    await _this.$api.avatar_upload_file(formData).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code == 0) {
                            _this.ruleForm.user_avatar = res.data.data;
                            _this.assistantForm.user_avatar = res.data.data;
                            _this.userAvaratImageUrl = this.imgUrl + res.data.data;
                            _this.dialogVisible = false;
                        } else {
                            _this.$message({
                                type: "error",
                                message: res.data.msg,
                            });
                        }
                    })

                })
            }
        },
        // 关闭对话框清除之前选择的文件
        closeDialog() {
            document.getElementById('uploads').value = ''
            document.getElementById('suploads').value = ''
        },
        // 搜索签约特属专家
        searchClientDoctors() {
            let start_date = '';
            let end_date = '';

            if (this.search_expired_date) {
                start_date = this.search_expired_date[0]
                end_date = this.search_expired_date[1]
            }
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'getClientDoctor',
                params: {
                    user_id: this.user_id,
                    start_start_date: start_date,
                    end_start_date: end_date,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    return;
                }

                this.allDoctor = [];
                let client_doctor = res.data.data.allDoctors;
                this.allManager = res.data.data.allManager;
                if (client_doctor) {
                    for (var i = 0; i < client_doctor.length; i++) {
                        //if (res.data.data.user_client_doctor[i].is_expired == 2) {
                        client_doctor[i].doctor_name = client_doctor[i].doctor_name + '/' + client_doctor[i].hospital_name
                        this.allDoctor.push(client_doctor[i]);
                        //}
                    }
                }


            });
        },

        // 特属服务对象资料导出到word
        async importinfo() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            let _that = this
            this.is_submit = true;
            let newDataArr = [];
            let assistants = [];
            let doctors = [];
            let manager = [];
            let contracts = [];
            let type_name = '';
            let user_name = this.user_name
            // 联系人
            for (let i = 0; i < this.allCustomer.length; i++) {
                assistants.push({
                    name: this.allCustomer[i].user_name,
                    mobile: this.allCustomer[i].mobile,
                    status: this.allCustomer[i].status_name,
                })
            }
            // 特属专家
            let doctor_name = '';
            for (let i = 0; i < this.allDoctor.length; i++) {
                doctor_name = this.allDoctor[i].doctor_name.split('/')[0];
                doctors.push({
                    name: doctor_name,
                    mobile: this.allDoctor[i].doctor_mobile,
                    hospital: this.allDoctor[i].hospital_nick_name || '',
                    department: this.allDoctor[i].department_name || '',
                    title: this.allDoctor[i].title_name || '',
                    start_date: this.allDoctor[i].start_date || '',
                    end_date: this.allDoctor[i].expired_date || '',
                })
            }

            // 签约记录

            for (let i = 0; i < this.allContract.length; i++) {
                type_name = this.allContract[i].contract_type == 2 ? '续约' : '新约';
                contracts.push({
                    doctor: this.allContract[i].doctor_name,
                    type: type_name,
                    start_date: this.allContract[i].start_date || '',
                    end_date: this.allContract[i].expired_date || '',
                    create_date: this.allContract[i].create_date || '',
                })
            }
            newDataArr.push({
                "avatar": await getBase64Image(this.user_avatar),
                "user_name": this.user_name,
                "status": this.status,
                "nick_name": this.nick_name || '',
                "idcard": this.idcard || '',
                "bloc_name": this.bloc_name || '',
                "mobile": this.mobile,
                "position": this.posistion || '',
                "expired_date": this.expired_date || '',
                "health_num": this.health_records_number || 0,
                "doctor_num": this.client_doctor_number || 0,
                "assistant_name": this.assistant_name || '',
                "assistant_mobile": this.assistant_mobile || '',
                "client_doctor_num": this.client_doctor_number || 0,
                "history_doctor_num": this.all_log_client_doctor_number || 0,
                "reservation_num": this.reservationing_number || 0,
                "int_num": this.reservation_interrupt_number || 0,
                "succ_num": this.reservationed_number || 0,
                "assistants": assistants,
                "manager": manager,
                "doctor": doctors,
                "contracts": contracts,
            })

            loadFile(
                "detail-user.docx",
                // "user.docx",
                function (error, content) {

                    if (error) {
                        this.is_submit = false;
                        throw error;
                    }

                    const zip = new PizZip(content);

                    let imageOpts = {}
                    imageOpts.centered = true;  // 图片居中，在word模板中定义方式为{%%image}
                    imageOpts.fileType = "docx";
                    imageOpts.getImage = function (newImgUrl) {
                        return base64Parser(newImgUrl);
                    }
                    imageOpts.getSize = function () {
                        return [190, 190]
                    }

                    const doc = new Docxtemplater(zip, {
                        paragraphLoop: true,
                        linebreaks: true,
                        modules: [new ImageModule(imageOpts)],
                    });

                    doc.render({
                        "user_info": newDataArr
                    });

                    const out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
                    // Output the document using Data-URI
                    saveAs(out, `特属服务对象资料-${user_name}.docx`);
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }
            );

        },
        // 导出服务中的签约专家到word
        async importDoctorInfo() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            let _that = this
            this.is_submit = true;
            let doctors = [];
            let user_name = this.user_name

            // 特属专家
            let doctor_name = '';
            let start_date = '';
            let end_date = '';
            for (let i = 0; i < this.allDoctor.length; i++) {
                doctor_name = this.allDoctor[i].doctor_name.split('/')[0];
                start_date = this.allDoctor[i].start_date.replaceAll('-', '/');
                end_date = this.allDoctor[i].expired_date.replaceAll('-', '/');

                doctors.push({
                    doctor_name: doctor_name,
                    mobile: this.allDoctor[i].doctor_mobile,
                    title: this.allDoctor[i].title_name || '',
                    strengths: this.allDoctor[i].strengths || '',
                    expired_date: start_date + '—' + end_date,
                })
            }


            loadFile(
                "user-annex.docx",
                // "user.docx",
                function (error, content) {

                    if (error) {
                        this.is_submit = false;
                        throw error;
                    }

                    const zip = new PizZip(content);


                    const doc = new Docxtemplater(zip, {
                        paragraphLoop: true,
                        linebreaks: true
                    });

                    doc.render({
                        "doctors": doctors,
                    });

                    const out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
                    // Output the document using Data-URI
                    saveAs(out, `${user_name}特属特属专家体名单.docx`);
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }
            );

        },
        // 验证是否有权限操作绑定的特属专家
        authCheck(data) {
            let userInfo = getUserInfos();
            if (userInfo) {
                let company_id = userInfo.company_id || 0
                let department_id = userInfo.department_id || 0
                let group_id = userInfo.group_id || 0
                let child_role_id = userInfo.child_role_id || 0
                let company_user_id = 0;
                if (child_role_id > 0) {
                    company_user_id = userInfo.company_user_id
                }
                let operate_users = data.admin_user_info
                if (userInfo.role_id != 3) {
                    return true;
                }
                for (let i = 0; i < operate_users.length; i++) {
                    if (child_role_id > 0) {
                        // 普通服务专员
                        if (operate_users[i].operate_user_id == company_user_id) {
                            return true;
                        }
                    } else {
                        // 组长
                        if (operate_users[i].company_id == company_id
                            && operate_users[i].department_id == department_id
                            && operate_users[i].group_id == group_id) {
                            return true;
                        }
                    }
                }
            }

            return false;
        }
    },
};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.cropper-content {
    .cropper {
        width: auto;
        height: 300px;
    }
}

.avatar-btn, .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-btn {
    display: inline-block;
    text-align: center;
}

.avatar-btn, .avatar-uploader .el-upload:hover {
    border-color: #d9d9d9;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar-btn {
    width: 200px;
    height: 200px;
}


.docker-detail-header {
    text-align: right;
    margin: 20px 0 20px 0;

    .el-button {
        height: 32px;
        line-height: 6px;
    }
}

.table .dockert_img_td {
    width: 5% !important;
    min-width: 140px !important;
    padding: 10px;
    text-align: center;
}

.table .docker_title_td {
    width: 10% !important;
    padding-right: 10px;
    text-align: right;
    background-color: #f9fafd;
}

.table .docker_value_td {
    width: 28% !important;
}

.message_box .message_title {
    text-align: left;
    font-size: 16px;
}

.message_box table {
    border-collapse: collapse !important;
    color: #606266;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
}

.message_box table tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
}

.message_box table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}

.message_box table tr:nth-child(1) {
    background-color: #f9fafd;
}

.message_box table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}

.message_box table tr > td:first-of-type {
    border-left: 0;
    border-bottom: 0;
}

.message_box table tr td {
    border-left: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
    font-size: 14px;
    padding: 15px 0 15px 10px;
    width: auto !important;
    text-align: center;
}

.table_message_box {
    margin: 50px 0px 20px 0px;
}

.search_data {
    float: right;
    margin: 15px 0px 15px 0px;
    width: 20%;
}

.image_box {
    height: 700px;
    overflow: hidden;
    overflow-y: auto;

    image {
        width: 100%;
    }
}

.upload_btn {
    position: absolute;
    top: 0;
    left: 30px;
}

.file_view {
    position: absolute;
    top: 0;
    left: 130px;
}

.doctor_search {
    text-align: left;
    width: 100%;
}

.el-table .admin_user_name .cell {
    white-space: pre-wrap;
}
</style>
